export default {
  SMALL: 767,
  MEDIUM: 959,
  LARGE: 1220,
  HD_READY: 1366,
  SMALL_LAPTOP: 1440,
  FULL_HD: 1920
};